/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { sortBy } from 'lodash';

export function sortByIgnoreCase<T>(field: string): (value: T[]) => T[] {
  return (entities: T[]) => <any[]>sortBy(entities, (entity: T) => entity[field].toLowerCase());
}
